import { useEffect } from 'react'
import { getLogoutRedirectUri } from 'helpers/logoutRedirect'

const FALLBACK_AFTER_LOGOUT = '/auth'

const toSafeRedirectTarget = (rawTarget: string) => {
  const trimmed = (rawTarget || '').trim()
  if (!trimmed) return FALLBACK_AFTER_LOGOUT

  if (
    trimmed === '/logout' ||
    trimmed.startsWith('/logout?') ||
    trimmed.startsWith('/logout#')
  ) {
    return FALLBACK_AFTER_LOGOUT
  }

  if (trimmed.startsWith('/')) {
    return trimmed
  }

  try {
    const url = new URL(trimmed)
    const isHttp = url.protocol === 'http:' || url.protocol === 'https:'
    const isSameOrigin =
      typeof window !== 'undefined' && url.origin === window.location.origin
    if (isHttp && isSameOrigin) {
      return url.toString()
    }
  } catch {
    // fall through to fallback
  }

  return FALLBACK_AFTER_LOGOUT
}

const Logout = () => {
  useEffect(() => {
    const target = toSafeRedirectTarget(getLogoutRedirectUri())
    window.location.replace(target)
  }, [])

  return null
}

export default Logout
